<template>
  <div class="order-process">
    <div class="icon-box">
      <ul>
        <li v-for="(item, index) in newTransForm" :key="index">
          <div class="left">
            <div class="img">
              <img :src="item.light ? item.activeIcon : item.icon" alt="" />
            </div>
            <span class="name" :class="{ active: item.light }">{{
              item.name
            }}</span>
            <div class="date" v-show="item.eventTime" >{{ item.eventTime }}</div>
          </div>
          <div class="right" v-show="index != transForm.length - 1" :class="{distance:newTransForm.length == 3}">
            <img :src="item.light ? arrowActive : arrow" alt="" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderProcess",
  props: {
    transForm: Array
  },
  data() {
    return {
      arrowActive: require("@/assets/img/orderDetail/arrow-active.png"),
      arrow: require("@/assets/img/orderDetail/arrow.png"),
      iconImgs: []
    };
  },
  computed: {
    newTransForm() {
      const newArr = [];
      this.transForm.forEach(item => {
        this.iconImgs.forEach(iten => {
          if (item.orderStatus === iten.name) {
            item = { ...item, ...iten };
          }
        });
         newArr.push(item);
      });
      return newArr;
    }
  }
  /* watch: {
    transForm: {
      deep: true,
      handler(newVal) {
        console.log(newVal, "newValnewValnewVal");
        const arr = [];
        this.iconImgs.forEach(item => {
          console.log(item);
          newVal.forEach(iten => {
            console.log(iten, "iten.nameiten.nameiten.name");
            if (item.name === iten.orderStatus) {
              item = { ...item, ...iten };
            }
          });
          arr.push(item);
        });
        this.iconImgs = [...arr];
      }
    }
  } */
};
</script>

<style scoped lang="scss">
.order-process {
  width: 100%;
  .tip {
    width: 96px;
    height: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 16px;
    margin: 12px 0;
  }
  .icon-box {
    height: 140px;
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-top: 4px solid #50aa43;
    ul {
      display: flex;
      justify-content: space-around;
      margin: 20px 0 0 14px;
      li {
        display: flex;
        justify-content: space-around;
        width: 260px;
        margin: 0 auto;
        .left {
          min-width: 80px;
          text-align: center;
          color: #999999;
          .img {
            img {
              width: 32px;
              height: 32px;
            }
          }
          .name {
            text-align: center;
            margin-top: 8px;
            font-size: 12px;
          }
          .date {
            font-size: 10px;
            width: 98px;
          }
          .active {
            font-weight: bold;
            color: #333333;
          }
        }
        .distance{
          margin-left: 99px;
        }
        .right {
          margin-top: 10px;
          img {
            width: 32px;
          }
        }
        &:last-child {
          margin-left: -15px;
        }
      }
    }
  }

}
</style>
